import { ClaimAction, ClaimState } from "./types";

export const setClaimRecord = (payload: Partial<ClaimState>) =>
  ({
    type: ClaimAction.SET_CLAIM_RECORD,
    payload,
  }) as const;

export const getClaimRecord = (payload: string) =>
  ({
    type: ClaimAction.GET_CLAIM_RECORD,
    payload,
  }) as const;

export const cleanUpClaim = () =>
  ({
    type: ClaimAction.CLEAN_UP,
  }) as const;

export const submitClaimTicket = (payload = {}, callBack = () => {}) =>
  ({
    type: ClaimAction.SUBMIT_TICKET,
    payload,
    callBack,
  }) as const;

export const sendEmail = (payload = {}, callBack = () => {}) =>
  ({
    type: ClaimAction.SEND_EMAIL,
    payload,
    callBack,
  }) as const;
